import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { routes } from 'appConstants';
import { _t } from 'utils';
import {
  ResolutionsHome,
  ResolutionsService,
  ResolutionsDetails,
} from 'containers';

const crumbs = [
  {
    label: _t('Библиотека экспортера'),
    to: routes.resolutions.root,
  },
];

const Resolutions = () => (
  <Switch>
    <Route
      path={routes.resolutions.root}
      exact
      component={ResolutionsHome}
    />
    <Route
      path={`${routes.resolutions.service.root}/:slug`}
      exact
      component={ResolutionsService}
    />
    <Route
      path={`${routes.resolutions.root}/:id`}
      exact
      render={() => (
        <ResolutionsDetails crumbs={crumbs} />
      )}
    />
  </Switch>
);

export default Resolutions;
